<template>
  <div class="lightbox align-end" v-show="modalOpen && !emptySlot">
    <div class="modal animate__animated animate__fadeInUp bg-white width-100 p15 text-left">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/**
 * Note:
 *  This modal component (Modal.vue) is responsible for the generic overlay window.
 *  The content is controlled by dynamic components, see the <slot> above.
 *  This way we can interchange the content as we wish.
 */

import _ from 'lodash'
export default {
  name: 'modal',
  data() {
    return {
      emptySlot : false
    }
  },
  computed: {
    modalOpen() {
      return this.$root.modalOpen;
    }
  },
  /**
   * Modal could block the view if not properly closed and user uses back/forward navigation.
   * And because $slots is not reactive, we double check it has a slot by using below.
   */
  created() {
    this.emptySlot = _.isEmpty(this.$slots);
  },
  beforeUpdate() {
    this.emptySlot = _.isEmpty(this.$slots);
  },
  methods: {
    abort() {
      this.$root.modalOpen = false;
    }
  }
}
</script>

<style>
.modal {
  max-height: calc(100vh - 100px);
  margin-bottom: 50px;
  padding-right: 0;
}

.modal button {
  background-color: white;
  color: var(--fasad-orange);
}
.modal-header {
  position: relative;
}
.modal-header:after {
  content: "";
  position: absolute;
  top: 100%;
  height: 25px;
  background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
  left: 0;
  right: 0;
}
.modal-wrap {
  display: grid;
  grid-template-rows: 25px 1fr 70px;
  max-height: calc(100vh - 150px);
}
.modal-wrap--35 {
  grid-template-rows: 35px 1fr 70px;
}
.modal-content {
  padding-top: 25px;
  overflow: auto;
  padding-bottom: 100px;
  padding-right: 15px;
}
.modal-buttons {
  margin-right: 15px;
  position: relative;
}
.modal-buttons:before {
  pointer-events: none;
  content: "";
  height: 75px;
  position: absolute;
  top: -75px;
  left: 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
}
.animate__animated {
  animation-duration: 350ms;
}
</style>
